import React, {useState} from 'react';
import Options from "./Options.js";
import user from "../assets/img/userbig.png";
import {REACT_APP_API_URL} from "../config.js";
import moment from 'moment';
import {useNavigate} from "react-router-dom";
import CustomLinesEllipsis from "./Mydata/CustomLinesEllipsis.js";

const RecommendationsItem = ({item, child_tasks, toLink, modalShow, getTaskData}) => {
    const [show, setShow] = useState(false);
    const navigate = useNavigate();

    const styleByStatus = (status) => {
        switch (status) {
            case "new":
                return "#707070";
            case "approved":
                return "#707070";
            case "process":
                return "#FF7700";
            case "end":
                return "#63c0ba";
            case "dead":
                return "rgba(179,38,38,0.79)";
            default:
                return "#000";
        }
    };


    let date_task = new Date(item?.end_date);
    let date_now = new Date();
    let date_end_task = new Date(item?.end_task_date);
    return (
        <div style={{backgroundColor: child_tasks ? "#ceefe9" : item?.end_date && date_now > date_task && !item?.end_task_date?"rgb(255 205 205)": ""}}
             className={item?.end_date && (item?.status === "end" && (date_task.getTime() < date_end_task.getTime()) || (item?.status === "process" && (date_task.getTime() < date_now.getTime()))) ? 'recommendations-item expired card' : 'recommendations-item card'}>
            {show && <Options id={item?.id} status={item?.status} creator={item?.creator} modalShow={() => {
                modalShow();
                setShow(false);
            }} close={() => {
                setShow(false);
                getTaskData();
            }} delete={() => console.log("delete")}/>}
            <div className='recommendations-item-cont' onClick={() => navigate(toLink)}>
                <div className='card-overflow'>
                    <div className='recommendations-item-top'>
                        <div className='recommendations-item-heading-icon'>
                            <span style={{color: styleByStatus(item?.status)}} className='icon-Component-21--1'/>
                            <div className='recommendations-item-heading'>{item?.name}</div>
                        </div>
                    </div>
                    <div className="tool-tip-cont">
                        <div className="tool-tip">{item?.company_name}</div>
                        <div className='company-name'>{item?.company_name}</div>
                    </div>
                    <div className='recommendations-item-text'>
                        <CustomLinesEllipsis text={item?.text} maxLines={2} />
                        <div className="process-file-message">
                            {item?.status === "process" &&
                            <div>{(item?.task_timer && item?.task_timer[item?.task_timer.length - 1]?.end === null) || item?.task_timer_active?
                                <span className="active">Ակտիվ</span> : <span className="passive">Պասիվ</span>}</div>}
                            <div className="recommendations-item-text-icon-cont">
                                {item?.is_voice && <div className="add-file">
                                    <div className="volume"/>
                                </div>}
                                {((item?.task_file && item?.task_file.length > 0) || item?.files_count > 0) &&
                                <div className='recommendations-item-text-icon'>
                                    <div className="add-file"><span className='icon-Attachment'/>
                                        <div className="tasks-around-cont">{+item?.new_file_count || +item?.unseen_files_count > 0  ? <div
                                            className="tasks-around">{+item?.new_file_count || +item?.unseen_files_count}</div>:null}
                                            {item?.new_sub_file_count ?
                                        <div
                                            className="sub-tasks-around tasks-around">{item?.new_sub_file_count}</div>:null}</div>
                                    </div>
                                </div>}
                                {((item?.sms_task && item?.sms_task.length > 0) || item?.sms_count > 0) &&
                                <div className='recommendations-item-text-icon'>
                                    <div className="add-file">{((item?.new_sms_count && item?.new_sms_count !== 0) ||  item?.unseen_sms_count !== 0 ) && <div
                                        className="tasks-around">{item?.new_sms_count || item?.unseen_sms_count}</div>}{(item?.sms_task?.length > 0 || item?.sms_count) &&
                                    <i className="far fa-envelope"/>}</div>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='recommendations-item-bottom'>
                    <hr/>
                    <div className='image-calendar'>
                        <div className="image-name-emplayee">
                            <img alt="img" className='task-image' src={item?.accountant_image || user}/>
                            <span
                                className="name-emplayee">{item?.accountant_first_name ? `${item?.accountant_first_name} ${item?.accountant_last_name}` :item?.accountant? `${item?.accountant?.fullname}` : item?.manager_name}</span>
                        </div>
                        <span className='calendar'>
                            <span className='icon-Calendar'/>
                            <div className="task-date-cont">
                                <span className='moment'>Ստղ. {item?.created_date ? moment(item?.created_date).format('LLL') : null}</span>
                                {item?.status !== "new" && <span className='moment'>Սկզ. {item?.start_task_date ? moment(item?.start_task_date).format('LLL') : null}</span>}
                                {item?.status === "end" && <span className='moment'>Ավտ. {item?.end_task_date ? moment(item?.end_task_date).format('LLL') : null}</span>}

                            </div>
                        </span>
                    </div>
                </div>
            </div>
            {((localStorage.getItem("profession") === "manager" && item?.status === "end") || item?.creator === `${REACT_APP_API_URL}user/${localStorage.getItem("user_id")}/` || item?.creator.id === +localStorage.getItem("user_id")) &&
            <span className="icon-Options" onClick={() => setShow(!show)}/>}
        </div>
    );
};

export default RecommendationsItem;
